module.exports = __webpack_public_path__ + "static/img/企业展厅智能体.e8419a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/operationDecision/企业展厅智能体.jpg
// module id = 3G/B
// module chunks = 0